const remoteConfigFetchVersionKey = 'remote-config-fetch-version';

// The web version Remote Config was last fetched for; null where localStorage is blocked, which fetches fresh.
export const getRemoteConfigFetchVersion = (): string | null => {
  try {
    return window.localStorage.getItem(remoteConfigFetchVersionKey);
  } catch {
    return null;
  }
};

export const setRemoteConfigFetchVersion = (version: string) => {
  try {
    window.localStorage.setItem(remoteConfigFetchVersionKey, version);
  } catch {
    // localStorage unavailable
  }
};
